<li class="marker-item" draggable="true" (dragstart)="onDragStart($event)">
  <div class="content-container">
    <span
      class="marker-image"
      inlineSVG="../../assets/icons/{{ marker.image }}"
    ></span>
    <span class="marker-label">{{ marker.markerName }}</span>
  </div>
</li>
